export const SPACING = {
  XS: '0.25rem',
  SM: '0.5rem',
  MD: '0.75rem',
  LG: '1rem',
  XL: '1.5rem',
  XXL: '2rem',
} as const;

export const BORDER_RADIUS = {
  SM: '0.5rem',
  MD: '0.75rem',
  LG: '1rem',
  XL: '1.25rem',
  PILL: '9999px',
} as const;

export const SHADOWS = {
  XS: '0 0.15rem 0.45rem rgba(0,0,0,0.04)',
  SM: '0 0.125rem 0.5rem rgba(0, 0, 0, 0.08)',
  MD: '0 0.5rem 1rem rgba(0, 0, 0, 0.10)',
  LG: '0 0.75rem 2rem rgba(0, 0, 0, 0.14)',
  SOFT: '0 0.2rem 0.6rem rgba(0,0,0,0.04)',
  DIALOG: '0 0.5rem 2rem rgba(0, 0, 0, 0.3)',
  MODAL: '0 0.75rem 2rem rgba(0,0,0,0.35)',
} as const;

export const TRANSITIONS = {
  DEFAULT: 'all 0.2s ease',
  SLIDE: 'left 0.2s ease',
} as const;

export const NEUTRAL_COLORS = {
  SURFACE_SUBTLE: '#F3F4F6',
  SURFACE_ALT: '#FAFAFA',
  BORDER_LIGHT: '#E5E5E5',
  BORDER_MUTED: '#D5D5D5',
} as const;

export const FONT_SIZES = {
  XS: '0.75rem',
  SM: '0.875rem',
  BASE: '1rem',
  LG: '1.125rem',
  XL: '1.5rem',
  XXL: '2.25rem',
} as const;
